import React from 'react'
import dayjs from '@helpers/dayjs'

import styles from './styles.module.css'

export default function Header() {
  const complaintDate = dayjs().format('DD-MM-YYYY')
  return (
    <div className={`row ${styles.head}`}>
      <h1 className={styles.title}>Libro de Reclamaciones</h1>
      <p>
        Conforme a lo establecido en código de la Protección y Defensa del consumidor contamos con
        un Libro de Reclamaciones a tu disposición para que puedas registrar tu queja o reclamo
        acerca de algún pedido o transacción realizada
      </p>
      <br />
      <h2>Hoja de reclamación</h2>
      <br />
      <p>Fecha de registro: {complaintDate}</p>
    </div>
  )
}
